import * as FlightInfo from './components/FlightInfo.module.css';

export default {
	FlightInfo
};
